import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { trackProductClick } from './MetaPixel';
export const HeroSection = () => {
  return <section className="mt-6 mb-8" data-id="element-48">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-blue-800 mb-3 leading-tight" data-id="element-49">
        The 7,000-Year Search for Pain-Free Sleep Finally Ends: How I Broke Free
        From the Devastating Cycle That Was Slowly Stealing My Life
      </h1>
      <div className="flex items-center text-gray-600 text-base mb-6" data-id="element-50">
        <span className="font-medium" data-id="element-51">By James Massey</span>
        <span className="mx-2" data-id="element-52">|</span>
        <span data-id="element-53">📅 26.06.2025</span>
      </div>
      <div className="bg-white p-4 border border-gray-200 rounded-lg mb-6" data-id="element-54">
        <div className="flex flex-col md:flex-row gap-4 items-center" data-id="element-55">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pDThfndrXmUJgoFVeHffTu/ChatGPT_Image_Jun_27%2C_2025%2C_12_09_45_AM.png" alt="Man experiencing back pain with red highlight on hip area" className="w-full md:w-1/2 rounded-lg object-cover h-64" data-id="element-56" />
          <div data-id="element-57">
            <p className="text-xl font-medium text-gray-800 mb-3" data-id="element-58">
              For three agonizing years, I lived in what I can only describe as
              "absolute sciatica hell."
            </p>
            <p className="text-gray-700 mb-4 text-lg" data-id="element-59">
              Every morning started the same way: that familiar, sharp shooting
              pain down my left leg the moment I tried to get out of bed. That
              deep, throbbing ache in my hip that made putting on pants feel
              like climbing Mount Everest.
            </p>
            <a href="https://relievana.com/products/relievana%E2%84%A2-alignment-pillow" className="bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg font-bold flex items-center justify-center w-full md:w-auto transition-colors text-lg" onClick={trackProductClick} data-id="element-60">
              Learn How I Found Relief
              <ChevronRightIcon className="ml-2" size={22} data-id="element-61" />
            </a>
          </div>
        </div>
      </div>
    </section>;
};